import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '../../models/role.model';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { ManageUserListComponent } from './manage-user/manage-user-list/manage-user-list.component';
import { AuditComponent } from './audit/audit.component';
import { ManageBillingListComponent } from './manage-billing/manage-billing-list/manage-billing-list.component';
import { ManageCaseComponent } from './manage-case/manage-case.component';
import { ManageCaseFieldsComponent } from './manage-case-fields/manage-case-fields.component';
import { ArchiveJobsComponent } from './archive-job/archive-jobs.component';
import { EditArchiveComponent } from './archive-job/edit-archive/edit-archive.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";

const routes: Routes = [
	{
		path: 'account',
		component: AppContainerComponent,
		children: [
			{
				path: 'manage-user',
				component: ManageUserListComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.AccountFeatureSet, Role.Administrator] }
			},
			{
				path: 'audit',
				component: AuditComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.AuditDocFeatureSet] }
			},
			{
				path: 'manage-billing',
				component: ManageBillingListComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.AccountFeatureSet, Role.Administrator, Role.Accounting] }
			},
			{
				path: 'manage-case',
				component: ManageCaseComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.AccountFeatureSet, Role.Administrator] }
			},
			{
				path: 'manage-case-fields',
				component: ManageCaseFieldsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.AccountFeatureSet, Role.Administrator] }
			},
			{
				path: 'archive-jobs',
				component: ArchiveJobsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Operations] }
			},
			{
				path: 'edit-archive/:id',
				component: EditArchiveComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Operations] }
			}
		]
	}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AccountRoutingModule {
}
